const restrictionReasons = [
  {
    label: 'Completed Aging Out Process',
    value: '1',
  },
  {
    label: 'Violence Against Staff/Member',
    value: '2',
  },
  {
    label: 'Physical Assault of Staff/Member',
    value: '3',
  },
  {
    label: 'Verbal Assault of Staff/Member',
    value: '4',
  },
  {
    label: 'Threatening of Staff/Member',
    value: '5',
  },
  {
    label: 'Being a Bad Neighbor',
    value: '6',
  },
  {
    label: 'Crime Related',
    value: '7',
  },
  {
    label: 'Creating Unsafe Space',
    value: '8',
  },
  {
    label: 'Other',
    value: '9',
  },
  {
    label: 'Inappropriate Behavior',
    value: '10',
  },
  {
    label: 'Stealing',
    value: '11',
  },
  {
    label: 'Check-In',
    value: '15',
  },
  {
    label: 'N/A',
    value: '19',
  },
  {
    label: 'Wellness Check',
    value: '17',
  },
  {
    label: 'Curfew',
    value: '16',
  },
  {
    label: 'Pocket Check',
    value: '18',
  },
  {
    label: 'Breach of Community Contract/Agreement',
    value: '20'
  },
];

export default restrictionReasons;

// SELECT
// GROUP_CONCAT(
//     CONCAT(
//         "  {\n",
//             "    label: '", label, "',\n"
//             "    value: '", `value`, "',\n"
//         '  },'
//     )
//     SEPARATOR
//     "\n"
// )
// FROM `civicrm_option_value`
// WHERE option_group_id=385